// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cn-b";
export var colorBlue = "_cn-8";
export var colorDot = "_cn-0";
export var colorDotLarge = "_cn-2";
export var colorDotSmall = "_cn-1";
export var colorGreen = "_cn-7";
export var colorGrey = "_cn-3";
export var colorOrange = "_cn-5";
export var colorPink = "_cn-a";
export var colorPurple = "_cn-9";
export var colorRed = "_cn-4";
export var colorYellow = "_cn-6";